(function($){

   jQuery.fn.serializeObject = function() {
      var arrayData, objectData;
      arrayData = this.serializeArray();
      objectData = {};
    
      jQuery.each(arrayData, function() {
        var value;
    
        if (this.value != null) {
          value = this.value;
        } else {
          value = '';
        }
    
        if (objectData[this.name] != null) {
          if (!objectData[this.name].push) {
            objectData[this.name] = [objectData[this.name]];
          }
    
          objectData[this.name].push(value);
        } else {
          objectData[this.name] = value;
        }
      });
    
      return objectData;
  };
    
    $('.hamburger').click(function() {
        $('.hamburger, .mobile-menu').toggleClass('is-active');
     });

     $('.filter-wrap__title').click(function(){
        //console.log(id);
        $('.filter-wrap__items').toggleClass('inactive');
        //$(".navigation-second:not(."+id+")").removeClass('active');
        $(this).toggleClass('inactive');
     });

     $('a.third-toggle').click(function(){
      $('.submenuthird').toggleClass('active');
   });

     $('a.dropdown-toggle').click(function(){
         var id = this.id;
         $('.'+id).toggleClass('active');
         $(".dropdown-menu:not(."+id+")").removeClass('active');
         $(this).toggleClass('active');
      });

     $('.table .prod_col.prod_diam').closest('.table ').addClass('diam-title_active');
     $('.table .prod_col.prod_spessore').closest('.table ').addClass('spessore-title_active');
     $('.table .prod_col.prod_foro').closest('.table ').addClass('foro-title_active');
     $('.table .prod_col.prod_grane').closest('.table ').addClass('grane-title_active');
     $('.table .prod_col.prod_udv').closest('.table ').addClass('udv-title_active');
     $('.table .prod_col.prod_max_rpm').closest('.table ').addClass('max_rpm-title_active');
     $('.table .prod_col.product_width').closest('.table ').addClass('width-title_active');
     $('.table .prod_col.prod_sviluppo').closest('.table ').addClass('sviluppo-title_active');
     $('.table .prod_col.prod_giunto').closest('.table ').addClass('giunto-title_active');
     $('.table .prod_col.prod_rotoli_m').closest('.table ').addClass('rotolim-title_active');
     $('.table .prod_col.prod_note').closest('.table ').addClass('note-title_active');
     $('.table .prod_col.prod_foro_mm').closest('.table ').addClass('foro_mm-title_active');
     $('.table .prod_col.prod_lunghezza_mm').closest('.table ').addClass('lunghezzamm-title_active');
     $('.table .prod_col.prod_lunghezza_m').closest('.table ').addClass('lunghezzam-title_active');
     $('.table .prod_col.prod_foridisp').closest('.table ').addClass('foridisp-title_active');
     $('.table .prod_col.prod_fororuota').closest('.table ').addClass('fororuota-title_active');
     $('.table .prod_col.prod_indicatoruota').closest('.table ').addClass('indicatoruota-title_active');
     $('.table .prod_col.prod_indicatoper').closest('.table ').addClass('indicatoper-title_active');
     $('.table .prod_col.prod_attacco').closest('.table ').addClass('attacco-title_active');
     $('.table .prod_col.prod_fori').closest('.table ').addClass('prodfori-title_active');
     $('.table .prod_col.prod_latiabrasivo').closest('.table ').addClass('latiabrasivo-title_active');
     $('.table .prod_col.prod_diam_gambo').closest('.table ').addClass('diamgambo-title_active');
     $('.table .prod_col.prod_rpm').closest('.table ').addClass('rpm-title_active');
     $('.table .prod_col.prod_forma').closest('.table ').addClass('forma-title_active');
     $('.table .prod_col.prod_durezza').closest('.table ').addClass('durezza-title_active');
     $('.table .prod_col.prod_use_diam').closest('.table ').addClass('usediam-title_active');
     $('.table .prod_col.prod_fori_ridotti').closest('.table ').addClass('prodforiridotti-title_active');
     $('.table .prod_col.prod_indicatoperarticoli').closest('.table ').addClass('prodindicatoperarticoli-title_active');
     $('.table .prod_col.prod_grado').closest('.table ').addClass('prodgrado-title_active');
     
     jQuery(function($){
         jQuery('.bnt_save').on('click', function(e){
            var regForm = jQuery("#update_user");
            var obj = regForm.serializeObject();
            //regForm.submit();
            var data = {
            'action':'update_user',
            'email':obj.user_email,
            'address':obj.user_address,
            'cap':obj.user_cap,
            'cell':obj.user_cell,
            'cf':obj.user_cf,
            'city':obj.user_city,
            'company':obj.user_company,
            'name':obj.user_name,
            'country':obj.user_naz,
            'piva':obj.user_piva,
            'prov':obj.user_prov,
            'surname':obj.user_surname,
            'tel':obj.user_tel,
            'type':obj.user_type,
            'password':obj.user_password ? obj.user_password : null,
            };
            jQuery.post('/wp-admin/admin-ajax.php', data, function(response) {
               
               $(".res").show();
        setTimeout(function(){$(".res").hide();},5000);

            });
         });
      });
      jQuery('#file-374').change(function() {
        var filename = this.files[0].name;
        //console.log(filename);
        jQuery('.res_cv').text(filename);
       });

      /*var tables = $('.productype table').get();
      console.log(tables);
      tables.forEach( (label, i) => { 
        tables[i].id += "table"+[i];
        // sort the table rows
        var sortedTableRows = $('#table'+i+' thead .table_legend th').get().sort(function (a, b) {
          var aVal = +a.getAttribute('sort-order');
          var bVal = +b.getAttribute('sort-order');
          return (aVal > bVal) ? 1 : (aVal < bVal) ? -1 : 0;
        });
  
        //substitute the table rows with the ordered one
        $.each(sortedTableRows, function (g, e) {
          $('#table'+i+' thead .table_legend').append(e);
        });
      });*/
  
})(jQuery);

